/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Node } from '../../core/models/Node';
import { ExternalDocumentation } from '../../core/models/common/ExternalDocumentation';

/**
 * Models an AsyncAPI external documentation node.
 * 
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {Node} parent
 * @class
 * @extends ExternalDocumentation
 */
export abstract class AaiExternalDocumentation extends ExternalDocumentation {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
AaiExternalDocumentation["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiExternalDocumentation";
AaiExternalDocumentation["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




